import { Form } from "react-bootstrap";
import Select from "react-select";

import styles from "./interestedPersonIssuingCertificatesInfo.module.css";

export default function InterestedPersonIssuingCertificatesInfo({
  inputData,
  certificateType,
  mode,
  fieldsOptions,
  updateNewData,
  errors = {},
  langErrors = {},
}) {
  const handleChange = (e) => {
    if (e) {
      if (e.target) {
        updateNewData(e.target.id, e.target.value);
      } else {
        updateNewData(e.key, e.value);
      }
    }
  };

  return (
    <>
      <div className={styles["container-information"]}>
        <p className={styles["description-text"]}>Сведения о заинтересованном лице</p>
        <div className={styles["inputs-container"]}>
          <div
            className={`${
              Number(certificateType) === 1
                ? styles["grid-container-interested-republican"]
                : styles["grid-container-interested-international"]
            }`}>
            {Object.values(fieldsOptions).map((item) => {
              if (item.needInWindow) {
                if (mode === "add" || mode === "edit") {
                  switch (item.type) {
                    case "selectSearch": {
                      const selectedValue = item.options.find((elem) => elem.value === inputData[item.key]);
                      return (
                        <Form.Group key={item.key} className={`${styles["common"]} ${styles[`box-${item.key}`]}`}>
                          <Form.Label>
                            {item.value}
                            {item.required && mode !== "view" && <span className={styles["red-dot"]}>*</span>}
                          </Form.Label>
                          <Select
                            noOptionsMessage={() => "Нет данных"}
                            onChange={(e) => handleChange(e)}
                            value={selectedValue ? selectedValue : ""}
                            className={`${styles["selectSearch"]} ${
                              mode !== "view" && !!errors[item.key] ? styles["red-border"] : null
                            }`}
                            classNamePrefix="select"
                            placeholder="Выберите"
                            id={item.key}
                            isDisabled={item.disabled || mode === "view"}
                            isSearchable={item.isSearchable}
                            name={item.key}
                            options={item.options}
                          />
                        </Form.Group>
                      );
                    }
                    default:
                      return (
                        <Form.Group
                          key={item.key}
                          controlId={`${item.key}`}
                          className={`${styles["common"]} ${styles[`box-${item.key}`]}`}>
                          <Form.Label>
                            {item.value}
                            {item.required && mode !== "view" && <span className={styles["red-dot"]}>*</span>}
                          </Form.Label>
                          <div className={styles["input-area"]}>
                            <Form.Control
                              onChange={(e) => handleChange(e)}
                              type={item.type}
                              // defaultValue={item.defaultValue}
                              value={inputData[item.key]}
                              as={item.textarea}
                              rows={3}
                              // readOnly={item.readOnly || mode === "view"}
                              disabled={item.disabled || mode === "view"}
                              lang={item.lang}
                              isInvalid={
                                (mode !== "view" && !!langErrors[item.key]) || !!errors[item.key]
                                // ||
                                // (!!item.maxlength && inputData[item.key]
                                //   ? inputData[item.key].length > item.maxlength
                                //   : false)
                              }
                            />
                            <Form.Control.Feedback type={"invalid"}>
                              {errors[item.key] || langErrors[item.key]}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      );
                  }
                } else {
                  return item?.caption ? (
                    <p key={item.key} className={`${styles["secondary-caption"]} ${styles[`box-${item.key}`]}`}>
                      {item.caption}
                    </p>
                  ) : (
                    <div key={item.key} className={`${styles["text-block"]} ${styles[`box-${item.key}`]}`}>
                      <p className={styles["option-label"]}>{item.value}</p>
                      <p className={styles["option-value"]}>
                        {item.type === "selectSearch"
                          ? item.options.find((elem) => elem.value === inputData?.[item.key])?.label || "—"
                          : item.type === "date" && inputData?.[item.key]
                          ? inputData?.[item.key].split("-").reverse().join(".")
                          : inputData?.[item.key] || "—"}
                      </p>
                    </div>
                  );
                }
              }
            })}
          </div>
        </div>
      </div>
    </>
  );
}
